<template>
  <v-dialog v-model="visible" max-width="600">
    <v-card>
      <v-card-title>Seleccionar cita</v-card-title>

      <v-card-text>
        <v-list>
          <v-list-item
            v-for="cita in citas"
            :key="cita.citaId"
            @click="seleccionar(cita)"
          >
            <v-list-item-content>
              <v-list-item-title>
                <strong>Folio de la cita:</strong> {{ cita.citaId }}
              </v-list-item-title>
                <v-list-item-subtitle>
                    <strong>Paciente:</strong> {{ cita.paciente }}<br>
                    <strong>Médico:</strong> {{ cita.medico }}<br>
                    <strong>Fecha y hora de la cita:</strong> {{ cita.fecha }}<br>
                </v-list-item-subtitle>
                <v-alert
                  text
                  prominent
                  type="error"
                  icon="mdi-close-circle"
                  v-if="cita.fechaCancelado"
                >
                  La cita ha sido cancelada el {{ cita.fechaCancelado }} - {{ cita.observacionesCancelado }}.
                  </v-alert>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn text @click="cerrar">Cancelar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  
</template>

<script>
export default {
  name: 'SeleccionarCitaDialog',
  props: {
    value: Boolean,      // para controlar apertura
    citas: Array
  },
  computed: {
    visible: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    seleccionar(cita) {
      this.$emit('cita-seleccionada', cita)
      this.cerrar()
    },
    cerrar() {
      this.$emit('input', false)
    }
  }
}
</script>
